module.exports = __webpack_public_path__ + "aab31f476a5083c6c548bceaa5f2b9ec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-witch.png
// module id = 1358
// module chunks = 0